/* Rainbow · configuratore "Collana Charms": catenina + ciondoli con foto e zoom.
   Dati in data-config (JSON dal metafield custom.charms_builder). Prezzo = varianti Shopify
   (Catenina × Numero ciondoli): qui si scelgono le radio nascoste e si scrivono le proprietà.
   Sorgente: tools/theme/assets/rb-charms-builder.js (control plane). */
(function () {
  function init(root) {
    if (!root || root.hasAttribute('data-rb-ready')) return;
    root.setAttribute('data-rb-ready', '1');
    var cfg; try { cfg = JSON.parse(root.getAttribute('data-config') || '{}'); } catch (e) { cfg = {}; }
    var catene = cfg.catene || [], famiglie = cfg.famiglie || [], prezzo = cfg.prezzo || {};
    var MAX = prezzo.max || 6, EXTRA = prezzo.catenaExtra || 2, PER = prezzo.ciondolo || 3;
    var es = (document.documentElement.getAttribute('lang') || '').slice(0, 2) === 'es';
    var T = es ? { cat: '1 · Elige la cadena', col: 'Color', ch: '2 · Elige los colgantes', chSub: 'Hasta ' + MAX + ', +' + PER + ' € cada uno. Toca para añadir, en el orden de izquierda a derecha.', tua: 'Tu collar', vuoto: 'Aún no hay colgantes: elige los que quieras arriba.', base: 'base', extra: '+' + EXTRA + ' €', per: '+' + PER + ' €', lettera: 'Elige la letra', colore: 'Elige el color', chiudi: 'Cerrar', zoom: 'Ampliar', togli: 'Quitar', pieno: 'Has llegado a ' + MAX + ' colgantes', req: 'Elige al menos un colgante antes de añadir al carrito', note: 'Notas (opcional)', notePh: 'Ej. la letra en el centro' }
      : { cat: '1 · Scegli la catenina', col: 'Colore', ch: '2 · Scegli i ciondoli', chSub: 'Fino a ' + MAX + ', +' + PER + ' € l’uno. Tocca per aggiungere, nell’ordine da sinistra a destra.', tua: 'La tua collana', vuoto: 'Ancora nessun ciondolo: scegli quelli che vuoi qui sopra.', base: 'base', extra: '+' + EXTRA + ' €', per: '+' + PER + ' €', lettera: 'Scegli la lettera', colore: 'Scegli il colore', chiudi: 'Chiudi', zoom: 'Ingrandisci', togli: 'Togli', pieno: 'Hai raggiunto ' + MAX + ' ciondoli', req: 'Scegli almeno un ciondolo prima di aggiungere al carrello', note: 'Note (facoltative)', notePh: 'Es. la lettera al centro' };

    var state = { catena: null, colore: 'Oro', ciondoli: [] }; // ciondoli: [{famiglia, colore, img, lettera}]
    var scope = root.closest('.product-info') || document;
    var wrap = root.closest('[data-rb-charms-builder-wrap]') || root.parentNode || root; // input proprietà e campo obbligatorio stanno nel contenitore, non dentro root
    var el = function (tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; };
    var big = function (u) { return (u || '').replace(/_\d+x(\.[a-z]+)(\?|$)/i, '_1200x$1$2'); };
    var txt = function (s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

    // ── markup ──────────────────────────────────────────────────────────────
    root.innerHTML = '';
    var secCat = el('section', 'rbcb-sec');
    secCat.appendChild(el('h3', 'rbcb-h', txt(T.cat)));
    var colRow = el('div', 'rbcb-colori');
    ['Oro', 'Argento'].forEach(function (c) { var b = el('button', 'rbcb-pill', txt(c)); b.type = 'button'; b.setAttribute('data-colore', c); b.addEventListener('click', function () { state.colore = c; render(); }); colRow.appendChild(b); });
    secCat.appendChild(colRow);
    var catRow = el('div', 'rbcb-row'); secCat.appendChild(catRow);
    root.appendChild(secCat);

    var secCh = el('section', 'rbcb-sec');
    secCh.appendChild(el('h3', 'rbcb-h', txt(T.ch) + ' <small>' + txt(T.chSub) + '</small>'));
    var grid = el('div', 'rbcb-grid'); secCh.appendChild(grid);
    var picker = el('div', 'rbcb-picker'); picker.hidden = true; secCh.appendChild(picker);
    root.appendChild(secCh);

    var secTua = el('section', 'rbcb-sec rbcb-tua');
    var tuaH = el('h3', 'rbcb-h'); secTua.appendChild(tuaH);
    var tuaRow = el('div', 'rbcb-sel'); secTua.appendChild(tuaRow);
    var reqMsg = el('p', 'rbcb-req', txt(T.req)); reqMsg.hidden = true; secTua.appendChild(reqMsg);
    root.appendChild(secTua);

    var lightbox = document.querySelector('.rbcb-zoom'); // uno solo per pagina (anche con la quick-view)
    if (!lightbox) {
      lightbox = el('div', 'rbcb-zoom'); lightbox.hidden = true;
      lightbox.innerHTML = '<div class="rbcb-zoom-in"><button type="button" class="rbcb-zoom-x" aria-label="' + txt(T.chiudi) + '">✕</button><img alt=""><p></p></div>';
      lightbox.addEventListener('click', function (e) { if (e.target === lightbox || e.target.classList.contains('rbcb-zoom-x')) { lightbox.hidden = true; document.body.style.overflow = ''; } });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !lightbox.hidden) { lightbox.hidden = true; document.body.style.overflow = ''; } });
      document.body.appendChild(lightbox);
    }
    function zoom(img, nome) { lightbox.querySelector('img').src = big(img); lightbox.querySelector('p').textContent = nome; lightbox.hidden = false; document.body.style.overflow = 'hidden'; }

    function card(img, nome, tag, on, extraCls) {
      var c = el('div', 'rbcb-card' + (extraCls ? ' ' + extraCls : ''));
      c.innerHTML = '<div class="rbcb-img"><img loading="lazy" alt="' + txt(nome) + '" src="' + txt(img || '') + '"></div><div class="rbcb-nome">' + txt(nome) + '</div>' + (tag ? '<div class="rbcb-tag">' + txt(tag) + '</div>' : '') + '<button type="button" class="rbcb-z" aria-label="' + txt(T.zoom) + '">🔍</button>';
      c.querySelector('.rbcb-z').addEventListener('click', function (e) { e.stopPropagation(); zoom(img, nome); });
      c.addEventListener('click', on);
      return c;
    }

    // ── catenine ────────────────────────────────────────────────────────────
    function renderCatene() {
      catRow.innerHTML = '';
      catene.forEach(function (c) {
        var col = (c.colori || []).filter(function (k) { return k.nome === state.colore; })[0] || (c.colori || [])[0];
        if (!col) return;
        var k = card(col.img || c.img, c.nome, c.base ? T.base : T.extra, function () { state.catena = c.nome; render(); }, state.catena === c.nome ? 'is-on' : '');
        k.setAttribute('data-catena', c.nome);
        catRow.appendChild(k);
      });
      colRow.querySelectorAll('.rbcb-pill').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-colore') === state.colore); });
    }

    // ── ciondoli ────────────────────────────────────────────────────────────
    function renderFamiglie() {
      grid.innerHTML = '';
      var pieno = state.ciondoli.length >= MAX;
      famiglie.forEach(function (f, i) {
        var k = card(f.img, f.nome, T.per, function () { if (state.ciondoli.length >= MAX) { flash(T.pieno); return; } apri(f, i); }, pieno ? 'is-off' : '');
        k.setAttribute('data-famiglia', f.nome);
        grid.appendChild(k);
      });
    }
    var aperta = null;
    function apri(f, i) {
      if (aperta === i && !picker.hidden) { picker.hidden = true; aperta = null; return; }
      aperta = i; picker.innerHTML = ''; picker.hidden = false;
      var scelta = { famiglia: f.nome, colore: f.colori.length === 1 ? f.colori[0].nome : null, img: f.colori.length === 1 ? f.colori[0].img : null, titolo: f.colori.length === 1 ? f.colori[0].titolo : null, lettera: null };
      var head = el('div', 'rbcb-pick-h', '<b>' + txt(f.nome) + '</b> <button type="button" class="rbcb-pick-x">' + txt(T.chiudi) + '</button>');
      head.querySelector('.rbcb-pick-x').addEventListener('click', function () { picker.hidden = true; aperta = null; });
      picker.appendChild(head);
      var needCol = f.colori.length > 1, needLet = !!(f.lettere && f.lettere.length);
      if (needCol) {
        picker.appendChild(el('div', 'rbcb-pick-l', txt(T.colore)));
        var cr = el('div', 'rbcb-row rbcb-row-s');
        f.colori.forEach(function (c) {
          var k = card(c.img, c.nome, null, function () { scelta.colore = c.nome; scelta.img = c.img; scelta.titolo = c.titolo; cr.querySelectorAll('.rbcb-card').forEach(function (x) { x.classList.toggle('is-on', x === k); }); done(); }, '');
          cr.appendChild(k);
        });
        picker.appendChild(cr);
      }
      if (needLet) {
        picker.appendChild(el('div', 'rbcb-pick-l', txt(T.lettera)));
        var lr = el('div', 'rbcb-lettere');
        f.lettere.forEach(function (L) { var b = el('button', 'rbcb-pill rbcb-let', txt(L)); b.type = 'button'; b.addEventListener('click', function () { scelta.lettera = L; lr.querySelectorAll('.rbcb-let').forEach(function (x) { x.classList.toggle('is-on', x === b); }); done(); }); lr.appendChild(b); });
        picker.appendChild(lr);
      }
      function done() {
        if (needCol && !scelta.colore) return; if (needLet && !scelta.lettera) return;
        aggiungi(scelta);
      }
      if (!needCol && !needLet) done();
      else picker.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    function aggiungi(s) {
      if (state.ciondoli.length >= MAX) { flash(T.pieno); return; }
      state.ciondoli.push({ famiglia: s.famiglia, colore: s.colore, img: s.img, titolo: s.titolo, lettera: s.lettera });
      picker.hidden = true; aperta = null;
      render();
      secTua.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    // dicitura reale del prodotto (titolo Shopify + variante); {L} = lettera scelta
    function etichetta(c) {
      if (c.titolo) { var t = c.titolo.indexOf('{L}') >= 0 ? c.titolo.replace('{L}', c.lettera || '') : c.titolo + (c.lettera ? ' ' + c.lettera : ''); return t.replace(/^Ciondolo\s+/i, ''); }
      return c.famiglia + (c.lettera ? ' ' + c.lettera : '') + (c.colore ? ' ' + c.colore.toLowerCase() : '');
    }
    function renderTua() {
      tuaH.innerHTML = txt(T.tua) + ' <span class="rbcb-count">' + state.ciondoli.length + ' / ' + MAX + '</span>';
      tuaRow.innerHTML = '';
      if (!state.ciondoli.length) { tuaRow.appendChild(el('p', 'rbcb-vuoto', txt(T.vuoto))); return; }
      state.ciondoli.forEach(function (c, i) {
        var k = el('div', 'rbcb-mini');
        k.innerHTML = '<span class="rbcb-n">' + (i + 1) + '</span><img alt="" src="' + txt(c.img || '') + '"><span class="rbcb-mini-t">' + txt(etichetta(c)) + '</span><button type="button" class="rbcb-x" aria-label="' + txt(T.togli) + '">✕</button>';
        k.querySelector('img').addEventListener('click', function () { zoom(c.img, etichetta(c)); });
        k.querySelector('.rbcb-x').addEventListener('click', function () { state.ciondoli.splice(i, 1); render(); });
        tuaRow.appendChild(k);
      });
    }
    var flashT = null;
    function flash(msg) { reqMsg.textContent = msg; reqMsg.hidden = false; clearTimeout(flashT); flashT = setTimeout(function () { reqMsg.hidden = true; reqMsg.textContent = T.req; }, 2500); }

    // ── varianti + proprietà ────────────────────────────────────────────────
    function fieldset(re) {
      var out = null;
      scope.querySelectorAll('fieldset[data-option-name], .product-form__input').forEach(function (fs) {
        var lg = fs.querySelector('legend'); var name = ((fs.getAttribute('data-option-name') || '') + ' ' + (lg ? lg.textContent : '')).toLowerCase();
        if (re.test(name) && !out) out = fs;
      });
      return out;
    }
    function pick(fs, pred) {
      if (!fs) return;
      var radios = fs.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) { var r = radios[i]; if (pred((r.value || '').trim())) { if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } return; } }
    }
    function hideFieldsets() {
      [fieldset(/catenina|cadena/), fieldset(/numero\s+ciondoli|n[uú]mero\s+de\s+colgantes/)].forEach(function (fs) { if (fs) { fs.style.display = 'none'; fs.setAttribute('data-rb-hidden', '1'); } });
      // vecchio widget Wrapin (casella "CLICCA NELLA CASELLA…"): doppione
      (scope === document ? document : scope).querySelectorAll("[class*='ptw-'], [id^='ptw-']").forEach(function (e) { e.style.setProperty('display', 'none', 'important'); });
    }
    function sync() {
      var n = state.ciondoli.length;
      pick(fieldset(/catenina|cadena/), function (v) { return state.catena && v.toLowerCase() === state.catena.toLowerCase(); });
      pick(fieldset(/numero\s+ciondoli|n[uú]mero\s+de\s+colgantes/), function (v) { return parseInt(v, 10) === Math.max(1, n); });
      var catTxt = state.catena ? state.catena + ' ' + state.colore.toLowerCase() : '';
      var chTxt = state.ciondoli.map(function (c, i) { return (i + 1) + '. ' + (c.titolo ? (c.titolo.indexOf('{L}') >= 0 ? c.titolo.replace('{L}', c.lettera || '') : c.titolo + (c.lettera ? ' ' + c.lettera : '')) : etichetta(c)); }).join(' · ');
      wrap.querySelectorAll('[data-rb-prop="catenina"]').forEach(function (h) { h.value = catTxt; h.disabled = !catTxt; });
      wrap.querySelectorAll('[data-rb-prop="ciondoli"]').forEach(function (h) { h.value = chTxt; h.disabled = !chTxt; });
      var req = wrap.querySelector('[data-rb-required]');
      if (req) { req.value = chTxt && catTxt ? chTxt : ''; req.required = true; if (req.value) req.classList.remove('required-picker'); }
      reqMsg.hidden = reqMsg.textContent !== T.req || !!chTxt || !req || !req.classList.contains('required-picker');
    }
    var note = wrap.querySelector('.rbcb-note textarea');
    if (note) { var noteSync = function () { note.disabled = !note.value.trim(); }; note.addEventListener('input', noteSync); noteSync(); }
    function render() { renderCatene(); renderFamiglie(); renderTua(); sync(); }

    // avvio: catenina base e colore dalla variante selezionata, se c'è
    var fsC = fieldset(/catenina|cadena/);
    if (fsC) { var sel = fsC.querySelector('input[type="radio"]:checked'); if (sel) state.catena = sel.value.trim(); }
    if (!state.catena) { var b = catene.filter(function (c) { return c.base; })[0] || catene[0]; state.catena = b ? b.nome : null; }
    hideFieldsets();
    render();
    var obs; try { obs = new MutationObserver(function () { hideFieldsets(); }); obs.observe(scope === document ? document.body : scope, { childList: true, subtree: true }); } catch (e) {}
    // messaggio "scegli almeno un ciondolo" quando il tema blocca l'aggiunta (classe required-picker)
    var req = wrap.querySelector('[data-rb-required]');
    if (req) { try { new MutationObserver(function () { if (req.classList.contains('required-picker') && !req.value) { reqMsg.textContent = T.req; reqMsg.hidden = false; secTua.scrollIntoView({ behavior: 'smooth', block: 'center' }); } }).observe(req, { attributes: true, attributeFilter: ['class'] }); } catch (e) {} }
  }
  function boot() { document.querySelectorAll('[data-rb-charms-builder]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
